export const updateMobileView = payload => {
    return {
        type: 'UPDATE_MOBILE_VIEW',
        payload,
    }
}

export const updateMobileOfferForm = payload => {
    return {
        type: 'UPDATE_OFFER_FORM',
        payload
    }
}

export const clearMobileOfferForm = () => {
    return {
        type: 'CLEAR_OFFER_FORM'
    }
}

export const updateProposalShiftsSelected = (payload) => {
    return {
        type: 'UPDATE_PROPOSAL_SHIFTS_SELECTED',
        payload
    }
}

export const updateRefreshedDates = (payload) => {
    return {
        type: 'UPDATE_REFRESHED_DATES',
        payload
    }
}

export const updateGlobalConfigs = payload => {
    return {
        type: 'UPDATE_GLOBAL_CONFIGS',
        payload
    }
}

export const updateMobilePaycodeForm = (payload) => ({
    type: 'UPDATE_PAYCODE_FORM',
    payload
});
